import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import SearchOverlay from "../common/Search/SearchOverlay";
import { useStrapiConstants } from "../../contexts/StrapiConstantsContext";
import Loading from "../common/Loading";
import Symposium from "../../features/symposium/Symposium";
const Navbar = () => {

    const { loaded, directorates, symposium } = useStrapiConstants();
    const location = useLocation();
    const [openDropdown, setOpenDropdown] = useState(null);
    const [mobileOpen, setMobileOpen] = useState(false);
    const [mobileDropdown, setMobileDropdown] = useState(null);
    const [openSearch, setOpenSearch] = useState(false);
    const navigate = useNavigate();

    const isActive = (path) => location.pathname === path;

    const toggleDropdown = (menu) => {
        setOpenDropdown(openDropdown === menu ? null : menu);
    };

    const toggleMobileDropdown = (menu) => {
        setMobileDropdown(mobileDropdown === menu ? null : menu);
    };

    const goToContactPage = () => {
        navigate("/iletisim"); // target page path
        setMobileOpen(false);
    };


    if (!loaded) return <Loading />;
    console.log(directorates)
    return (
        <>
            {/* Top Bar */}
            <div className="bg-[#005aab] py-2  border-b border-white/10">
                <div className="max-w-[1400px] mx-auto px-6">
                    <div className="flex justify-end items-center">
                        <span className="text-white text-sm tracking-wide"></span>
                    </div>
                </div>
            </div>

            {/* Main Navbar */}
            <nav className="bg-white shadow-md border-b border-gray-200 sticky top-0 z-50">
                <div className="max-w-[1200px] mx-auto px-4 md:px-0 ">
                    <div className="flex items-center justify-between h-20 relative">

                        {/* Logo Area */}
                        <Link
                            to="/"
                            className="group flex items-center gap-4 py-2 shrink-0 transition-all duration-300"
                        >
                            {/* Logo Image with Hover Zoom */}
                            <img
                                src="/esam-logo.png"
                                alt="ESAM Logo"
                                className="h-12 w-auto object-contain transition-transform duration-300 group-hover:scale-105 drop-shadow-sm"
                            />

                            {/* Vertical Divider (Hidden on mobile if needed, or keeps layout clean) */}
                            <div className="hidden sm:block h-10 w-[1px] bg-gray-300 group-hover:bg-[#005aab] transition-colors duration-300"></div>

                            {/* Styled Text */}
                            <div className="flex flex-col justify-center">
                                <h1 className="font-bold text-lg leading-none text-[#20559d] tracking-tight group-hover:text-[#005aab] transition-colors duration-300">
                                    Ekonomik ve Sosyal
                                </h1>
                                <span className="text-xs font-medium text-gray-500 uppercase tracking-[0.15em] mt-1 group-hover:tracking-[0.2em] group-hover:text-[#005aab] transition-all duration-300">
                                    ARAŞTIRMALAR MERKEZİ
                                </span>
                            </div>
                        </Link>









                        {/* Desktop Menu */}
                        <ul className="hidden md:flex items-center gap-2 ml-auto">
                            {/* Desktop Menu */}
                            <ul className="hidden md:flex items-center gap-2 ml-auto">

                                {/* Sempozyumlar */}
                                {symposium?.length > 0 && (
                                    <li
                                        className="relative h-14 flex items-center"
                                        onMouseEnter={() => toggleDropdown("sempozyumlar")}
                                        onMouseLeave={() => toggleDropdown(null)}
                                    >
                                        <span
                                            className={`px-5 h-full flex items-center rounded-md cursor-pointer font-medium text-[0.95rem] transition
                ${isActive("/sempozyumlar")
                                                    ? "bg-blue-100 text-gray-700 font-semibold"
                                                    : "text-[#20559d]"
                                                }`}
                                        >
                                            Sempozyumlar
                                        </span>

                                        {openDropdown === "sempozyumlar" && (
                                            <DropdownMenu>
                                                {symposium.slice(0, 4).map((item) => (
                                                    <DropdownItem
                                                        key={item.documentId}
                                                        to={`/sempozyumlar/${item.slug}`}
                                                    >
                                                        {item.displayTitle}
                                                    </DropdownItem>
                                                ))}

                                                <DropdownItem to="/sempozyumlar">
                                                    Hepsini incele...
                                                </DropdownItem>
                                            </DropdownMenu>
                                        )}
                                    </li>
                                )}

                            </ul>




                            {/* Kurumsal */}
                            <li
                                className="relative h-14 flex items-center"
                                onMouseEnter={() => toggleDropdown("kurumsal")}
                                onMouseLeave={() => toggleDropdown(null)}
                            >
                                <span
                                    className={`px-5 h-full flex items-center rounded-md cursor-pointer font-medium text-[0.95rem] transition
                    ${isActive("/kurumsal")
                                            ? "bg-blue-100 text-gray-700 font-semibold"
                                            : "text-[#20559d]"
                                        }`}
                                >
                                    Kurumsal
                                </span>

                                {openDropdown === "kurumsal" && (
                                    <DropdownMenu>
                                        <DropdownItem to="kurumsal/kurumsal-kimlik-rehberi">
                                            Esam İstanbul Kurumsal Kimlik Rehberi
                                        </DropdownItem>
                                        <DropdownItem to="kurumsal/misyon-vizyon">
                                            Misyon & Vizyon
                                        </DropdownItem>
                                        <DropdownItem to="kurumsal/baskan">
                                            Başkan
                                        </DropdownItem>
                                        <DropdownItem to="kurumsal/yonetim-kurulu">
                                            Yönetim Kurulu
                                        </DropdownItem>
                                    </DropdownMenu>
                                )}
                            </li>

                            {/* Basın */}
                            <li
                                className="relative h-14 flex items-center"
                                onMouseEnter={() => toggleDropdown("basin")}
                                onMouseLeave={() => toggleDropdown(null)}
                            >
                                <span
                                    className={`px-5 h-full flex items-center rounded-md cursor-pointer font-medium text-[0.95rem] transition
                    ${isActive("/basin")
                                            ? "bg-blue-100 text-gray-700 font-semibold"
                                            : "text-[#20559d]"
                                        }`}
                                >
                                    Basın
                                </span>

                                {openDropdown === "basin" && (
                                    <DropdownMenu>
                                        <DropdownItem to="/basin/haberler">Duyurular & Haberler</DropdownItem>
                                        <DropdownItem to="/basin/yayinlar">Yayınlar</DropdownItem>
                                        <DropdownItem to="/basin/dergiler">Dergiler</DropdownItem>
                                    </DropdownMenu>
                                )}
                            </li>
                            {/* Direktörlüklerimiz */}
                            {directorates?.length > 0 && (
                                <li
                                    className="relative h-14 flex items-center"
                                    onMouseEnter={() => toggleDropdown("direktor")}
                                    onMouseLeave={() => toggleDropdown(null)}
                                >
                                    <span
                                        className={`px-5 h-full flex items-center rounded-md cursor-pointer font-medium text-[0.95rem] transition
            ${isActive("/direktorluklerimiz")
                                                ? "bg-blue-100 text-gray-700 font-semibold"
                                                : "text-[#20559d]"
                                            }`}
                                    >
                                        Direktörlüklerimiz
                                    </span>

                                    {openDropdown === "direktor" && (
                                        <DropdownMenu>
                                            {directorates.slice(0, 6).map((item) => (
                                                <DropdownItem
                                                    key={item.documentId}
                                                    to={`/direktorlukler/${item.slug}`}
                                                >
                                                    {item.displayTitle}
                                                </DropdownItem>
                                            ))}

                                            <DropdownItem to="/direktorlukler">
                                                Hepsini incele...
                                            </DropdownItem>
                                        </DropdownMenu>
                                    )}
                                </li>
                            )}

                            {/* Contact */}
                            <li className="relative h-14 flex items-center">
                                <Link
                                    to="/iletisim"
                                    className={`px-5 h-full flex items-center rounded-md font-medium text-[0.95rem] transition
                    ${isActive("/iletisim")
                                            ? "bg-blue-100 text-gray-700 font-semibold"
                                            : "text-[#20559d]"
                                        }`}
                                >
                                    Bize Ulaşın
                                </Link>
                            </li>

                            {/* Search Button */}
                            <div
                                className="ml-4 border-2 border-gray-300 rounded-md px-3 py-2 text-lg transition hover:bg-gray-100 cursor-pointer"
                                onClick={() => setOpenSearch(true)}
                            >
                                🔍
                                <SearchOverlay isOpen={openSearch} onClose={() => setOpenSearch(false)} />

                            </div>
                        </ul>

                        {/* Mobile Menu Button */}
                        <button
                            className="md:hidden text-3xl"
                            onClick={() => setMobileOpen(!mobileOpen)}
                        >
                            ☰
                        </button>
                    </div>

                    {/* Mobile Menu (collapsible) */}
                    {mobileOpen && (
                        <ul className="md:hidden flex flex-col gap-3 py-4 border-t border-gray-200">
                            {/* Kurumsal Mobile Dropdown */}
                            <li>
                                <button
                                    onClick={() => toggleMobileDropdown("kurumsal")}
                                    className="w-full text-left text-lg font-medium text-[#20559d] py-2 flex justify-between items-center"
                                >
                                    Kurumsal
                                    <span className="text-sm">{mobileDropdown === "kurumsal" ? "▲" : "▼"}</span>
                                </button>
                                {mobileDropdown === "kurumsal" && (
                                    <ul className="pl-4 mt-2 space-y-2">
                                        <li>
                                            <Link
                                                to="kurumsal/kurumsal-kimlik-rehberi"
                                                className="block text-gray-700 py-1"
                                                onClick={() => setMobileOpen(false)}
                                            >
                                                Esam İstanbul Kurumsal Kimlik Rehberi
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="kurumsal/misyon-vizyon"
                                                className="block text-gray-700 py-1"
                                                onClick={() => setMobileOpen(false)}
                                            >
                                                Misyon & Vizyon
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="kurumsal/baskan"
                                                className="block text-gray-700 py-1"
                                                onClick={() => setMobileOpen(false)}
                                            >
                                                Başkan
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="kurumsal/yonetim-kurulu"
                                                className="block text-gray-700 py-1"
                                                onClick={() => setMobileOpen(false)}
                                            >
                                                Yönetim Kurulu
                                            </Link>
                                        </li>
                                    </ul>
                                )}
                            </li>

                            {/* Basın Mobile Dropdown */}
                            <li>
                                <button
                                    onClick={() => toggleMobileDropdown("basin")}
                                    className="w-full text-left text-lg font-medium text-[#20559d] py-2 flex justify-between items-center"
                                >
                                    Basın
                                    <span className="text-sm">{mobileDropdown === "basin" ? "▲" : "▼"}</span>
                                </button>
                                {mobileDropdown === "basin" && (
                                    <ul className="pl-4 mt-2 space-y-2">
                                        <li>
                                            <Link
                                                to="/basin/haberler"
                                                className="block text-gray-700 py-1"
                                                onClick={() => setMobileOpen(false)}
                                            >
                                                Duyurular & Haberler
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="/basin/yayinlar"
                                                className="block text-gray-700 py-1"
                                                onClick={() => setMobileOpen(false)}
                                            >
                                                Yayınlar
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="/basin/dergiler"
                                                className="block text-gray-700 py-1"
                                                onClick={() => setMobileOpen(false)}
                                            >
                                                Dergiler
                                            </Link>
                                        </li>
                                    </ul>
                                )}
                            </li>

                            {/* Direktörlüklerimiz Mobile Dropdown */}
                            {directorates?.length > 0 && (
                                <li>
                                    <button
                                        onClick={() => toggleMobileDropdown("direktor")}
                                        className="w-full text-left text-lg font-medium text-[#20559d] py-2 flex justify-between items-center"
                                    >
                                        Direktörlüklerimiz
                                        <span className="text-sm">
                                            {mobileDropdown === "direktor" ? "▲" : "▼"}
                                        </span>
                                    </button>

                                    {mobileDropdown === "direktor" && (
                                        <ul className="pl-4 mt-2 space-y-2">
                                            {directorates.slice(0, 3).map((item) => (
                                                <li key={item.documentId}>
                                                    <Link
                                                        to={`/direktorlukler/${item.slug}`}
                                                        className="block text-gray-700 py-1"
                                                        onClick={() => setMobileOpen(false)}
                                                    >
                                                        {item.displayTitle}
                                                    </Link>
                                                </li>
                                            ))}

                                            <li>
                                                <Link
                                                    to="/direktorlukler"
                                                    className="block text-gray-700 py-1"
                                                    onClick={() => setMobileOpen(false)}
                                                >
                                                    Hepsini incele...
                                                </Link>
                                            </li>
                                        </ul>
                                    )}
                                </li>
                            )}

                            {symposium?.length > 0 && (
                                <li>
                                    <button
                                        onClick={() => toggleMobileDropdown("sempozyumlar")}
                                        className="w-full text-left text-lg font-medium text-[#20559d] py-2 flex justify-between items-center"
                                    >
                                        Sempozyumlar
                                        <span className="text-sm">
                                            {mobileDropdown === "sempozyumlar" ? "▲" : "▼"}
                                        </span>
                                    </button>

                                    {mobileDropdown === "sempozyumlar" && (
                                        <ul className="pl-4 mt-2 space-y-2">
                                            {symposium.slice(0, 3).map((item) => (
                                                <li key={item.documentId}>
                                                    <Link
                                                        to={`/sempozyumlar/${item.slug}`}
                                                        className="block text-gray-700 py-1"
                                                        onClick={() => setMobileOpen(false)}
                                                    >
                                                        {item.displayTitle}
                                                    </Link>
                                                </li>
                                            ))}

                                            <li>
                                                <Link
                                                    to="/sempozyumlar"
                                                    className="block text-gray-700 py-1"
                                                    onClick={() => setMobileOpen(false)}
                                                >
                                                    Hepsini incele...
                                                </Link>
                                            </li>
                                        </ul>
                                    )}
                                </li>
                            )}


                            {/* Bize Ulaşın */}
                            <li>
                                <button
                                    onClick={goToContactPage}
                                    className="block text-lg font-medium text-[#20559d] py-2"
                                >
                                    Bize Ulaşın
                                </button>
                            </li>
                            <li>
                                <div
                                    className="border-gray-300 rounded-md py-2 text-lg transition hover:bg-gray-100 block text-lg font-medium text-[#20559d] py-2"
                                    onClick={() => setOpenSearch(true)}
                                >
                                    Arama Yapın     🔍
                                    <SearchOverlay isOpen={openSearch} onClose={() => setOpenSearch(false)} />

                                </div>
                            </li>
                        </ul>
                    )}
                </div>
            </nav>
        </>
    );
};

/* --- Dropdown Components --- */

const DropdownMenu = ({ children }) => (
    <ul className="absolute top-full left-0 bg-white shadow-xl rounded-lg py-2 border border-gray-200 min-w-[220px] z-[999]">
        {children}
    </ul>
);

const DropdownItem = ({ to, children }) => (
    <li>
        <Link
            to={to}
            className="block px-5 py-3 text-gray-700 hover:bg-blue-50 hover:font-medium transition text-[0.95rem]"
        >
            {children}
        </Link>
    </li>
);

export default Navbar;